module.exports = __webpack_public_path__ + "static/media/1 Train-Lateral_Z1.46bf5201.png";